import {createSelector} from '@reduxjs/toolkit';

import {UI_MODES} from '../constants/index.js';
import {getResolutionForZoom} from '../util/map.js';
import dimensions from '@explorer/styles/dimensions.js';

const TIMELINE_HEIGHT = dimensions.timeline.height;
const LEFT_SIDEBAR_WIDTH = dimensions.leftSidebar.width;
const RIGHT_SIDEBAR_WIDTH = dimensions.rightSidebar.width;

const getSize = state => state.ui.size;
const getCenter = state => state.map.center;
export const getZoom = state => state.map.zoom;
const getLeftSidebarVisible = state => state.ui.drawers.left !== '';
const getRightSidebarVisible = state => state.ui.drawers.right !== '';
const getTimelineVisible = state => state.ui.mode !== UI_MODES.COMPARE;

export const getResolution = createSelector([getZoom], getResolutionForZoom);

// Returns visible map center in projected coordinates.
export const getVisibleCenter = createSelector(
  [
    getCenter,
    getResolution,
    getLeftSidebarVisible,
    getTimelineVisible,
    getRightSidebarVisible,
  ],
  (
    center,
    resolution,
    leftSidebarVisible,
    timelineVisible,
    rightSidebarVisible
  ) => {
    let x = center[0];

    if (leftSidebarVisible) {
      x += (resolution * LEFT_SIDEBAR_WIDTH) / 2;
    }
    if (rightSidebarVisible) {
      x -= (resolution * RIGHT_SIDEBAR_WIDTH) / 2;
    }

    let y = center[1];
    if (timelineVisible) {
      y += (resolution * TIMELINE_HEIGHT) / 2;
    }

    return [x, y];
  }
);

export const getVisiblePixelExtent = createSelector(
  [getLeftSidebarVisible, getTimelineVisible, getSize, getRightSidebarVisible],
  (leftSidebarVisible, timelineVisible, size, rightSidebarVisible) => {
    const minX = leftSidebarVisible ? LEFT_SIDEBAR_WIDTH : 0;
    const maxX = rightSidebarVisible
      ? size.width - RIGHT_SIDEBAR_WIDTH
      : size.width;
    const minY = 0;
    const maxY = timelineVisible ? size.height - TIMELINE_HEIGHT : size.height;

    return [minX, minY, maxX, maxY];
  }
);

export const getVisibleExtent = createSelector(
  [getVisibleCenter, getResolution, getVisiblePixelExtent],
  (center, resolution, pixelExtent) => {
    const halfWidth = (resolution * (pixelExtent[2] - pixelExtent[0])) / 2;
    const halfHeight = (resolution * (pixelExtent[3] - pixelExtent[1])) / 2;
    const minX = center[0] - halfWidth;
    const minY = center[1] - halfHeight;
    const maxX = center[0] + halfWidth;
    const maxY = center[1] + halfHeight;
    return [minX, minY, maxX, maxY];
  }
);
